import { createSlice } from '@reduxjs/toolkit';
import { IExternalParams } from '../../types/externalParams';

const initialState: IExternalParams = {};

const externalParamsSlice = createSlice({
  name: 'externalParams',
  initialState,
  reducers: {},
});

export const { reducer: externalParamsReducer } = externalParamsSlice;
